import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const QuestionPreview = lazy(() =>
  import(/* webpackChunkName: "QuestionPreview" */ '../../components/survey_editor/preview/QuestionPreview')
);

export default function QuestionPreviewComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <QuestionPreview {...props} />
    </Suspense>
  );
}
